import type { InputSignal, OutputEmitterRef } from '@angular/core';

import type { BulkItemBase } from '@core/bulk-actions-legacy';

import type { AnyGroup, GroupsState } from './data/groups.types';
import type { ViewRecordData, ViewStoreMeta } from './data/layout-types';
import type { ViewRecord } from './data/record-types';
import type { Swimlane, SwimlaneId, SwimlanesState } from './data/swimlanes-types';
import type { GroupId } from './data/types';

export interface SwimlanesRecordsData {
  swimlane: Swimlane | null;
  groups: Array<ViewRecordData<ViewRecord>>;
}

export interface SwimlanesData {
  swimlaneGroupingId: string | null;
  swimlanesState: SwimlanesState | null;
  swimlanesMeta: ViewStoreMeta | null;
  groupingId: string | null;
  groupsState: GroupsState | null;
  groupsMeta: ViewStoreMeta | null;
  data: SwimlanesRecordsData[];
}

export interface DragData {
  vsGroup: ViewRecordData<ViewRecord>;
  vsSwimlane: SwimlanesRecordsData | null;
}

type InSwimlaneMove = {
  groupConfigId: string;
  fromGroupId: GroupId;
  toGroupId: GroupId;
  swimlaneConfigId: null;
  fromSwimlaneId: null;
  toSwimlaneId: null;
};
type CrossSwimlaneMove = {
  groupConfigId: string;
  fromGroupId: GroupId;
  toGroupId: GroupId;
  swimlaneConfigId: string;
  fromSwimlaneId: SwimlaneId;
  toSwimlaneId: SwimlaneId;
};
export type MoveToParams = InSwimlaneMove | CrossSwimlaneMove;

/**
 * Wrap record to make it uniq between groups
 */
export const isBulkItemWrapped = Symbol('wrapped');
export interface BulkItemWrapped {
  id: string;
  record: BulkItemBase;
  [isBulkItemWrapped]: true;
}

export type GroupSelectionType = 'indeterminate' | 'all' | null;
export interface LayoutBoardGroupHeader {
  group: InputSignal<AnyGroup>;
  selectionInGroup: InputSignal<GroupSelectionType>;
  count: InputSignal<number | null | undefined>;
  select: OutputEmitterRef<AnyGroup>;
}
